import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { FormV2ServiceService } from '../form-v2-service.service';
import { OrderWithFilesContractor } from '../form-model/OrderWithFilesContractor';

@Component({
  selector: 'app-order-with-files-contractors',
  templateUrl: './order-with-files-contractors.component.html',
  styleUrls: ['./order-with-files-contractors.component.scss']
})
export class OrderWithFilesContractorsComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  lista: OrderWithFilesContractor[] = [];
  szukaj = '';
  nowyNumer = '';

  edytowanyId: number = null;
  edytowanyNumer = '';
  usuwanyId: number = null;

  wczytywanie = false;
  zapisuje = false;
  blad = '';
  komunikat = '';
  czyZmieniono = false;

  @ViewChild('edycjaInput') set edycjaInput(el: ElementRef<HTMLInputElement>) {
    if (el) {
      setTimeout(() => el.nativeElement.focus());
    }
  }

  constructor(public dialogRef: MatDialogRef<OrderWithFilesContractorsComponent>, private formService: FormV2ServiceService) { }

  ngOnInit(): void {
    this.pobierz();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  get przefiltrowana(): OrderWithFilesContractor[] {
    const fraza = this.szukaj.trim().toLowerCase();
    if (fraza === '') {
      return this.lista;
    }
    return this.lista.filter(x => x.Numer.toLowerCase().includes(fraza));
  }

  pobierz() {
    this.wczytywanie = true;
    this.subscriptions.push(this.formService.GetOrderWithFilesContractorsAll().subscribe((data) => {
      this.lista = data;
      this.wczytywanie = false;
    }, (err) => {
      this.wczytywanie = false;
      this.pokazBlad(err);
    }));
  }

  dodaj() {
    const numer = this.nowyNumer.trim();
    if (numer === '' || this.zapisuje) {
      return;
    }
    if (this.lista.some(x => x.Numer === numer)) {
      this.ustawBlad(`Numer ${numer} już jest na liście`);
      return;
    }
    this.zapisuje = true;
    this.subscriptions.push(this.formService.AddOrderWithFilesContractor(numer).subscribe((data) => {
      this.lista = [...this.lista, data].sort((a, b) => a.Numer.localeCompare(b.Numer));
      this.nowyNumer = '';
      this.zapisuje = false;
      this.czyZmieniono = true;
      this.ustawKomunikat(`Dodano ${data.Numer}`);
    }, (err) => {
      this.zapisuje = false;
      this.pokazBlad(err);
    }));
  }

  edytuj(item: OrderWithFilesContractor) {
    this.usuwanyId = null;
    this.edytowanyId = item.Id;
    this.edytowanyNumer = item.Numer;
  }

  anulujEdycje() {
    this.edytowanyId = null;
    this.edytowanyNumer = '';
  }

  zapiszEdycje(item: OrderWithFilesContractor) {
    const numer = this.edytowanyNumer.trim();
    if (numer === '' || this.zapisuje) {
      return;
    }
    if (numer === item.Numer) {
      this.anulujEdycje();
      return;
    }
    this.zapisuje = true;
    this.subscriptions.push(this.formService.UpdateOrderWithFilesContractor(item.Id, numer).subscribe((data) => {
      const stary = item.Numer;
      item.Numer = data.Numer;
      this.lista = [...this.lista].sort((a, b) => a.Numer.localeCompare(b.Numer));
      this.zapisuje = false;
      this.czyZmieniono = true;
      this.anulujEdycje();
      this.ustawKomunikat(`Zmieniono ${stary} → ${data.Numer}`);
    }, (err) => {
      this.zapisuje = false;
      this.pokazBlad(err);
    }));
  }

  potwierdzUsuniecie(item: OrderWithFilesContractor) {
    this.anulujEdycje();
    this.usuwanyId = item.Id;
  }

  usun(item: OrderWithFilesContractor) {
    if (this.zapisuje) {
      return;
    }
    this.zapisuje = true;
    this.subscriptions.push(this.formService.RemoveOrderWithFilesContractor(item.Id).subscribe(() => {
      this.lista = this.lista.filter(x => x.Id !== item.Id);
      this.usuwanyId = null;
      this.zapisuje = false;
      this.czyZmieniono = true;
      this.ustawKomunikat(`Usunięto ${item.Numer}`);
    }, (err) => {
      this.zapisuje = false;
      this.pokazBlad(err);
    }));
  }

  zamknij() {
    this.dialogRef.close(this.czyZmieniono);
  }

  private pokazBlad(err: any) {
    const tresc = err?.error?.Message ?? (typeof err?.error === 'string' ? err.error : null) ?? 'Wystąpił błąd. Spróbuj ponownie.';
    this.ustawBlad(tresc);
  }

  private ustawBlad(tresc: string) {
    this.komunikat = '';
    this.blad = tresc;
  }

  private ustawKomunikat(tresc: string) {
    this.blad = '';
    this.komunikat = tresc;
  }
}
